import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import LanguageContext from "components/LanguageContext";
import TagsContainer from "components/templatesComponents/tagsDSFR/TagsContainer";
import TagSelectable from "components/templatesComponents/tagsDSFR/TagSelectable";
import TagsList from "components/templatesComponents/tagsDSFR/TagsList";
import PropTypes from "prop-types";
import React, { useContext, useMemo, useState } from "react";
import { withRouter } from "react-router-dom";
import { getTranslateIndex } from "utils/commonUtils";
import t from "utils/locales/translation.json";
import wrappable from "utils/wrappable";

const GlossaryItem = wrappable((props) => {
  const { word, description } = props;

  return (
    <Box sx={{ mb: 4, "& h4": { mb: 1 } }}>
      <h4>{word}</h4>
      <p>{description}</p>
    </Box>
  );
});

const allKey = "Tout";

const Glossary = (props) => {
  let { items = [] } = props;
  const { language } = useContext(LanguageContext);

  const [selectedLetter, setSelectedLetter] = useState(allKey);

  if (items && !Array.isArray(items)) {
    items = [items];
  }

  const filteredItems = items.filter((item) => item && item.word);

  filteredItems.sort((a, b) => a.word.localeCompare(b.word));

  const groupedItems = useMemo(() => {
    const initialGroupedItems = {};
    filteredItems.forEach((item) => {
      const { word } = item;
      const firstLetter = word.toUpperCase().split("")[0];
      initialGroupedItems[firstLetter] = initialGroupedItems[firstLetter] || [];
      initialGroupedItems[firstLetter].push(item);
    });
    return initialGroupedItems;
  }, [filteredItems]);

  const letters = useMemo(() => {
    const allLetters = Object.keys(groupedItems).map((item) => item);
    allLetters.unshift(allKey);
    return allLetters;
  }, [groupedItems]);

  const filteredGroupedItems = useMemo(() => {
    if (selectedLetter === "Tout") {
      return { items: groupedItems, total: items.length };
    }
    const newGroupedItems = {};
    let termsCount = 0;
    if (groupedItems[selectedLetter]) {
      newGroupedItems[selectedLetter] = groupedItems[selectedLetter];
      termsCount += groupedItems[selectedLetter].length;
    }

    if (termsCount === 0) {
      return { items: {}, total: 0 };
    }

    return { items: newGroupedItems, total: termsCount };
  }, [groupedItems, selectedLetter, items]);

  return (
    <Stack spacing={4} sx={{ pt: 3, px: { xs: 2, lg: 0 }, "& li": { position: "relative" } }}>
      <TagsContainer>
        <TagsList
          Component={TagSelectable}
          tags={letters}
          handleSelectTags={setSelectedLetter}
          selectedTags={[selectedLetter]}
          disabledTag
        />
      </TagsContainer>
      <h4>
        {filteredGroupedItems.total}{" "}
        {t[language].components.glossary_title[getTranslateIndex(filteredGroupedItems.total)]}
      </h4>
      <Box>
        {Object.keys(filteredGroupedItems.items)
          .sort((a, b) => a.localeCompare(b))
          .map((letter) => (
            <Box sx={{ mb: 8.25, "& h2": { mb: 0 } }} id={letter} key={letter}>
              <h2>{letter}</h2>
              <hr />
              {groupedItems[letter].map((item) => (
                <GlossaryItem key={item.id} {...item} />
              ))}
            </Box>
          ))}
      </Box>
    </Stack>
  );
};

Glossary.propTypes = {
  location: PropTypes.shape().isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()),
};

export default withRouter(Glossary);
